import {EmptyControl, MaxLength, MinLength, NestedArray, Required} from '@hvlng/framework-bff/core';
import {HvlDateConverter} from '@hvlng/framework-bff/util';
import {JsonObject, JsonProperty} from 'json2typescript';
import {PerEntityInfoAttributesModel} from "./per-entity-info-attributes-model";
import {PerAdvancedSearchRuleModel} from "./per-advanced-search-rule-model";

@JsonObject('KovanHrPerAdvancedSearchEntityModel')
export class PerAdvancedSearchEntityModel {
    @EmptyControl()
    @JsonProperty('condition', String, true)
    condition: string = 'and';
    @EmptyControl()
    @JsonProperty('entity', String, true)
    entity: string = null;

    @NestedArray(PerAdvancedSearchRuleModel)
    @EmptyControl()
    @JsonProperty('rules', [PerAdvancedSearchRuleModel], true)
    rules: Array<PerAdvancedSearchRuleModel> = new Array<PerAdvancedSearchRuleModel>();


}
